export default function removeSpace(value?: string) {
  return value?.replace(/\s/g, '');
}
